import { axiosPrivate } from '@app/dashboard/tools/axios/axiosInstance';

export const fetchReachPortalSsoUrl = async () => {
    return axiosPrivate.post('/reach/sso_auth/');
};
